export default {
    namespaced: true,
    state: {
        isDialogOpened: false,
        incident: {},
    },
    getters: {
        getDialogState(state) {
            return state.isDialogOpened;
        },
        getIncidentDetails(state) {
            return state.incident;
        },
    },
    mutations: {
        TOGGLE_DIALOG(state) {
            state.isDialogOpened = !state.isDialogOpened;
            if (state.isDialogOpened === false) {
                state.incident = {};
            }
        },
        SET_INCIDENT(state, incident) {
            state.incident = incident;
        },
    }
}